import requestField from "@/store/modules/requestField";

const state = {pskTable: []};

const actions = {
  addPskTable: ({commit, dispatch}, newPsk) => {
    //если таблички одинаковые, то не творим новый гавнокодик в промисах
    if (JSON.stringify(state.pskTable) !== JSON.stringify(newPsk)) {
      commit('updatePsk', newPsk);
    }
  }
};

const mutations = {
  updatePsk: (state, newPsk) => {
    state.pskTable = newPsk;
  }
};

const getters = {
  getAvailableSum: (state, getters, rootState) => {
    let result = [];

    try {
      let out = state.pskTable.filter(item => {
        //получаем доступнные варианты сумм для выбранного продукта
        return item.ProductType === getters.getTargetFieldValue('PRODUCT_ID')
        && parseInt(getters.getTargetFieldValue('CALC_WEEK'),10) === parseInt(item.Period, 10)
      }).sort(function (a, b) {
        return a.Amount - b.Amount;
      });

      out.forEach(value => {
        let findResult = result.find(valueF => {
          return valueF == value.Amount;
        });

        if (findResult === undefined) {
          result.push(value.Amount);
        }
      })
    } catch (e) {
      console.log(e);
    }
    try {
      if (result.length > 0) {
        rootState['requestField']['sendData']['request']['CALC_SUMM'] = result[result.length - 1];
      }
    } catch (e) {
      console.log(e)
    }
    return result;
  },
  getProduct: (state, getters, rootState) => {
    let result = [];
    try {
      state.pskTable.forEach(value => {
        let findResult = result.find(valueF => {
          return valueF.ProductType == value.ProductType;
        });
        if (findResult === undefined) {
          result.push({ProductType: value.ProductType, DlProductTypeName: value.DlProductTypeName});
        }
      });
    } catch (e) {
      console.log(e);
    }
    // try {
    //   if (result.length > 0) {
    //     rootState['requestField']['sendData']['request']['PRODUCT_ID'] = result[result.length - 1]['ProductType'];
    //   }
    // } catch (e) {
    //   console.log(e);
    // }
    return result;
  },
  getAvailablePeriod: (state, getters, rootState) => {
    let result = [];
    try {
      // выводим простыню по данному продукту product_id
      let currentPsk = state.pskTable.filter(value => value.ProductType === rootState.requestField.sendData.request.PRODUCT_ID);
      // находим уникальные значение по периоду в полученной простыне
      currentPsk.forEach(value => {
        let findResult = result.find(valueF => {
          return valueF == value.Period
        });
        if (findResult === undefined) {
          result.push(value.Period);
        }
      });
    } catch (e) {
      console.log(e);
    }
    try {
      if (result.length > 0) {
        rootState['requestField']['sendData']['request']['CALC_WEEK'] = result[result.length - 1];
      }

    } catch (e) {
      console.log(e);
    }
    return result;

  },
  getSelectedPskInfo: (state, getters, rootState) => {
    //ишем соовтевтсиве в табличке по сумме и типу продукта
    let filteredRow = state.pskTable.filter(item => {
      return item.Amount == getters.getTargetFieldValue('CALC_SUMM')
        && item.ProductType == getters.getTargetFieldValue('PRODUCT_ID')
        && item.Period == getters.getTargetFieldValue('CALC_WEEK')
    });
    if (filteredRow.length == 1) {
      //возращаем значение для данной суммы с расширением переплата продукта
      filteredRow[0]['OutDeltaPayments'] = filteredRow[0]['OutPayments'] - getters.getTargetFieldValue('CALC_SUMM');

      //костыль отображение информации
      if(filteredRow[0]['vwFixedPay'] != null) {
        filteredRow[0]['FixedPay'] = filteredRow[0]['vwFixedPay'];
      }
      if(filteredRow[0]['vwOutDeltaPayments'] != null) {
        filteredRow[0]['OutDeltaPayments'] = filteredRow[0]['vwOutDeltaPayments'];
      }
      if(filteredRow[0]['vwOutPayments'] != null) {
        filteredRow[0]['OutPayments'] = filteredRow[0]['vwOutPayments'];
      }


      //хардкор костыль на красивое окончание
      switch (filteredRow[0]['PeriodType_id']) {
        case '1':
          filteredRow[0]['calcWeekTitle'] = '(Недели)';
          filteredRow[0]['periodPayTitle'] = 'Еженедельный';
          break;
        case '2':
          filteredRow[0]['calcWeekTitle'] = '(Месяцы)';
          filteredRow[0]['periodPayTitle'] = 'Ежемесячный';
          break;
        default:
          filteredRow[0]['calcWeekTitle'] = '';
          filteredRow[0]['periodPayTitle'] = '';
          break;
      }
      return filteredRow[0];
    } else {
      return {
        Amount: 0,
        DlProductTypeName: '-',
        FixedPay: 0,
        OutPayments: 0,
        PercentageRate: 0,
        Period: 0,
        ProductType: 0,
        DlProductTypeID: 0,
        PeriodType: 0,
        PeriodType_id: 0,
        OutDeltaPayments: 0
      };
    }
  }
};

export default {
  state,
  mutations,
  getters,
  actions
}
